export default __webpack_public_path__ + "static/media/modulocker.d0736dc0.png";